module.exports = __webpack_public_path__ + "images/home/index/values-assign-header-bc85428e70115e834004ea04968010d4.png";